import React, { useState, useEffect } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input, Select, Tooltip } from "antd";
import CustomSelect from "../../../../../components/Elements/Select/CustomSelect";
import { API_URLS } from "../../../../../api/apiUrls";
import { postApi } from "../../../../../api/api_instance";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../../../components/Elements/DialogBox/AcceptDialog";
import { getApi } from "../../../../../api/api_instance";
import { THEME_COLORS } from "../../../../../color";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
import { useSelector, useDispatch } from "react-redux";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  fetchAllLocations,
  fetchAllDepartments,
  fetchLinkedItems,
} from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
const CreateUsers = ({ onOpen, onClose }) => {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [location, setLocation] = useState("");
  const [department, setDepartment] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  const {
    orgMode: setupOrgMode,
    locationList,
    departmentList,
    linkedItems,
    loadingParams,
  } = useSelector((state) => state.orgSetup);

  const authUser = useSelector((state) => state.auth.user);
  const orgMode = setupOrgMode || authUser?.orgStructureMode;

  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const clientId = authUser?.client_id?._id || authUser?._id;
  const pageSize = 10;

  const [errorMessage, setErrorMessage] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    role: "",
    employeeId: "",
    contactNo: "",
    status: "",
  });

  //  ????

  const roleOptions = [
    // { label: "Customer Admin", value: "customer_admin" },
    // { label: "Sub Admin", value: "sub_admin" },
    // { label: "Group Admin", value: "group_admin" },
    { label: "Employee", value: "employee" },
    { label: "Vendor", value: "vendor" },
    { label: "User", value: "user" },
  ];

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const handleSave = async () => {
    const errors = {};

    if (!name?.trim()) {
      errors.name = "Name is required";
    }

    if (!email?.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Please enter a valid email address";
    }

    if (!role || role.length === 0) {
      errors.role = "At least one role is required";
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return;
    }

    setErrorMessage({});
    setLoading(true);

    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_USER,
        data: {
          name,
          email,
          role: Array.isArray(role) ? role : role ? [role] : [],
          locationId: location || null,
          departmentId: department || null,
        },
      });

      if (response?.success) {
        triggerPopup(
          "success",
          "Success",
          response?.message || "User created successfully.",
          2000,
        );
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        triggerPopup(
          "error",
          "Failed",
          response?.message || "Something went wrong. Please try again.",
          3000,
        );
      }
    } catch (error) {
      triggerPopup(
        "error",
        "Error",
        error?.response?.data?.message || "An unexpected error occurred.",
        3000,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };

  useEffect(() => {
    dispatch(fetchAllLocations());
    dispatch(fetchAllDepartments());
  }, [dispatch]);

  const handleDeptChange = (val) => {
    setDepartment(val);
    setLocation(""); // Reset location when department changes
    if (orgMode === "department-first") {
      dispatch(fetchLinkedItems(val));
    }
  };

  const handleLocChange = (val) => {
    setLocation(val);
    setDepartment(""); // Reset department when location changes
    if (orgMode === "location-first") {
      dispatch(fetchLinkedItems(val));
    }
  };

  const departmentOptions = (
    (orgMode === "department-first"
      ? departmentList
      : orgMode === "location-first"
        ? linkedItems
        : departmentList) || []
  )
    .filter(Boolean)
    .map((dept) => ({
      label: dept?.department_name || dept?.name || "Unnamed Department",
      value: dept?._id,
    }));

  const locationOptions = (
    (orgMode === "location-first"
      ? locationList
      : orgMode === "department-first"
        ? linkedItems
        : locationList) || []
  )
    .filter(Boolean)
    .map((loc) => ({
      label: loc?.location_name || loc?.name || "Unnamed Location",
      value: loc?._id,
    }));

  const handleLocationChange = (val) => {
    setLocation(val); // val should be the _id
  };

  const handleRoleChange = (selectedRoles) => {
    if (selectedRoles.includes("vendor")) {
      if (!role.includes("vendor")) {
        // Vendor was just added, clear other roles and select only vendor
        setRole(["vendor"]);
      } else {
        // Vendor was already selected, but user selected another role, so remove vendor
        setRole(selectedRoles.filter((r) => r !== "vendor"));
      }
    } else {
      setRole(selectedRoles);
    }
  };

  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3
            className="text-xl font-bold "
            style={{ color: THEME_COLORS.green }}
          >
            Add New{" "}
          </h3>
          {/* <div className="w-1/3 h-1 bg-gradient-to-r from-green-500 to-blue-600 mt-2"></div> */}
        </div>
        <div className="rounded-xl border mt-8 px-5 sm:px-12 pt-4 ">
          <div className="flex flex-col gap-6">
            <div>
              <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri">
                Name <span className="text-red-500">*</span>
              </label>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                className="h-14 rounded-lg"
              />
              {errorMessage.name && (
                <div className="text-red-500 text-sm">{errorMessage.name}</div>
              )}
            </div>

            {/* <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="User Name"
              className="h-14 rounded-lg"
            />
            {errorMessage.username && (
              <div className="text-red-500 text-sm">
                {errorMessage.username}
              </div>
            )} */}
            <div>
              <label className="flex items-center text-sm font-semibold text-[#000000] mb-1 font-calibri">
                <span>
                  Email <span className="text-red-500">*</span>
                </span>

                <Tooltip
                  title="Once created, the email address cannot be changed. Please verify before saving."
                  styles={{
                    root: {
                      maxWidth: 280,
                    },
                    body: {
                      backgroundColor: "#ffffff",
                      color: "#06513D",
                      border: "1px solid #06513D",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                      fontSize: "13px",
                    },
                  }}
                >
                  <span className="text-[#06513D] cursor-pointer text-[13px]">
                    <InfoCircleOutlined
                      style={{
                        margin: "0 0 0 8px",
                        color: "#06513D",
                        fontSize: 14,
                      }}
                    />
                  </span>
                </Tooltip>
              </label>

              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="h-14 rounded-lg"
              />
              {errorMessage.email && (
                <div className="text-red-500 text-sm">{errorMessage.email}</div>
              )}
            </div>

            {/* <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Location"
              className="h-14 rounded-lg"
            />
            {errorMessage.location && (
              <div className="text-red-500 text-sm">{errorMessage.location}</div>
            )} */}

            {/* <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="h-14 rounded-lg"
            />
            {errorMessage.password && (
              <div className="text-red-500 text-sm">
                {errorMessage.password}
              </div>
            )} */}

            {/* <Input
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              placeholder="Employee ID"
              className="h-14 rounded-lg"
            />
            {errorMessage.employeeId && (
              <div className="text-red-500 text-sm">
                {errorMessage.employeeId}
              </div>
            )} */}

            {/* <Input
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
              placeholder="Contact Number"
              className="h-14 rounded-lg"
            /> */}

            {/* {errorMessage.contactNo && (
              <div className="text-red-500 text-sm">
                {errorMessage.contactNo}
              </div>
            )} */}
            {/* ✅ Multi-Selector for Role */}
            <div>
              <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri ">
                Role <span className="text-red-500">*</span>
              </label>

              <CustomSelect
                options={roleOptions}
                mode="multiple"
                height="40px"
                placeholder="Select Role(s)"
                value={role}
                onChange={handleRoleChange}
              />
              {errorMessage.role && (
                <div className="text-red-500 text-sm">{errorMessage.role}</div>
              )}
            </div>

            {/* ✅ Location & Department based on Org Mode */}
            {orgMode === "department-first" ? (
              <>
                {/* Department First */}
                <div>
                  <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri">
                    Department
                  </label>
                  <CustomSelect
                    options={departmentOptions}
                    height="40px"
                    placeholder="Select Department"
                    value={department}
                    onChange={handleDeptChange}
                  />
                </div>

                {/* Linked Location */}
                <div>
                  <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri">
                    Location
                  </label>
                  <CustomSelect
                    options={locationOptions}
                    height="40px"
                    placeholder="Select Location"
                    value={location}
                    onChange={(val) => setLocation(val)}
                    disabled={!department}
                  />
                </div>
              </>
            ) : (
              <>
                {/* Location First */}
                <div>
                  <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri">
                    Location
                  </label>
                  <CustomSelect
                    options={locationOptions}
                    height="40px"
                    placeholder="Select Location"
                    value={location}
                    onChange={handleLocChange}
                  />
                </div>

                {/* Linked Department */}
                <div>
                  <label className="block text-sm font-semibold text-[#000000] mb-1 font-calibri">
                    Department
                  </label>
                  <CustomSelect
                    options={departmentOptions}
                    height="40px"
                    placeholder="Select Department"
                    value={department}
                    onChange={(val) => setDepartment(val)}
                    disabled={!location}
                  />
                </div>
              </>
            )}
          </div>

          <div className="flex justify-center gap-6 p-5">
            <button
              onClick={handleCancel}
              // style={{
              //   background: "#fff",
              //   height: "40px",
              //   width: "120px",
              //   borderRadius: "10px",
              //   border: "1px solid #ebedf3",
              //   color: "#000",
              // }}
              className="text-[#06513D] hover:!bg-[#F8F8F8] hover:!border-[#06513D] h-10 w-24 bg-[#E6EDEB] border border-[#06513D] font-[700] text-[16px] leading-[100%] tracking-[0%] font-[calibri] rounded-md"
            >
              Cancel
            </button>
            <button
              loading={loading}
              onClick={handleSave}
              // style={{
              //   background:
              //     "linear-gradient(106.08deg, #18DEB4 5.8%, #032E9D 94.99%)",
              //   height: "40px",
              //   width: "120px",
              //   borderRadius: "10px",
              // }}
              className="text-[16px] leading-[100%] tracking-[0%] font-[calibri] border rounded-md font-[700] h-10 w-24 border-none text-white bg-[#06513D] hover:!bg-[#387464]"
            >
              Save
            </button>
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </DialogBox>
      {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={() => {
            setShowAcceptDialog(false);
            onClose();
          }}
          heading="User Created"
          subheading="The new user has been successfully created."
          success={true}
        />
      )}
    </>
  );
};

export default CreateUsers;
